import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import WithRoles from '@hobs/hocs/WithRoles';
import Tooltip from '@hobs/components/Tooltip';
import { H1 } from '@hobs/components/Headings';
import {
  getServiceRequests,
  clearMealPlanner,
  getMealPlannerForSubmit,
  updateServiceRequests,
  queryLocationsForMealPlanner
} from '@hobs/actions/mealPlanner';

import _MealPlanner from '@hobs/containers/MealPlanner';
import './MealPlanner.scss';

class MealPlanner extends _MealPlanner {
  renderNationFilter() {
    return null;
  }

  renderHeader() {
    const { t } = this.props;
    return (
      <div className="meal-planner--header">
        <H1>{t('Meal planner')}</H1>
      </div>
    );
  }

  canRenderNation() {
    return false;
  }

  canSplitMealPlanner() {
    return false;
  }

  onDialogOpening = () => {};

  renderKitchenDialog() {}

  renderKitchenName(serviceRequest) {
    const { t } = this.props;

    return serviceRequest.kitchenName ? (
      <Tooltip tooltip={serviceRequest.kitchenName} position="top">
        {serviceRequest.kitchenName}
      </Tooltip>
    ) : (
      <span>{t('Unspecified')}</span>
    );
  }
}

const mapStateToProps = state => ({
  serviceRequests: state.mealPlanner.serviceRequests,
  forSubmit: state.mealPlanner.forSubmit,
  mealPlannerLocations: state.mealPlanner.mealPlannerLocations
});

const mapDispatchToProps = {
  getServiceRequests,
  clearMealPlanner,
  queryLocationsForMealPlanner,
  getMealPlannerForSubmit,
  updateServiceRequests
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withRouter(WithRoles(MealPlanner))));
